import { DropdownButton } from "../Button"
import { Text } from "../Typography"
import * as styles from "./paginationButtonStyles"
import { filterOptionsForTotal } from "./paginationButtonUtils"

type PaginationButtonDataTestIds = {
  root?: string
  button?: string
  list?: string
  listItem?: string
}

export type PaginationButtonProps = Omit<React.ComponentPropsWithRef<"div">, "onChange"> &
  Readonly<{
    total: number
    value: number
    options: ReadonlyArray<number>
    onChange: (value: number) => void
    dataTestIds?: PaginationButtonDataTestIds
  }>

export const PaginationButton = ({ total, value, options, onChange, dataTestIds }: PaginationButtonProps) => {
  const filteredOptions = filterOptionsForTotal(options, total)
  return (
    <div data-testid={dataTestIds?.root}>
      <Text css={styles.text} tag="span">
        Showing
      </Text>
      {filteredOptions ? (
        <DropdownButton<number>
          value={value}
          action={(size: number) => onChange(size)}
          items={filteredOptions.map((size) => ({
            text: size.toString(),
            value: size,
            dataTestId: dataTestIds?.listItem ? `${dataTestIds.listItem}-${size}` : undefined,
          }))}
          dataTestIds={{
            button: dataTestIds?.button,
            list: dataTestIds?.list,
          }}
          css={{
            root: styles.button,
          }}
          direction="up"
          variant="pagination"
        />
      ) : (
        <Text css={styles.total} tag="span">
          {total}
        </Text>
      )}
      <Text css={styles.text} tag="span">
        of {total} results
      </Text>
    </div>
  )
}
